<template>
  <div class="content-wrapper">

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Proceso Acreditación"
          directory="Evaluación / Testificación"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">

        </div>
      </div>
    </div>

    <div class="mb-primary">
      <div class="d-flex justify-content-between mb-3">
      </div>
      <app-tab :tabs="tabsHorizontal" type="horizontal" />
    </div>

  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";

export default {
  extends: CoreLibrary,
  name: "PendingAssignmentsIndex",
  data() {
    return {
      tabsHorizontal: [
        {
          icon: "file-text",
          name: "Elaboración Plan de Evaluación",
          component: "tab-pending-assignments",
          permission: "",
        },
        {
          icon: "file-text",
          name: "Elaboración Informe de Evaluación",
          component: "tab-pending-assignments",
          permission: "",
        },
      ],
    };
  }
};
</script>
